import {
  emptyAdresse,
  adressField,
  adressTyp,
  storageKasse,
  tAdresse,
} from 'src/shared/frontendTypes/kasse'

import { shippingType } from 'src/shared/dbTypes/order'

import clone from 'src/functions/cloner'

type emptyAdresse = typeof emptyAdresse

const normalizeAdressLand = <T extends emptyAdresse>(adresse: T): T => ({
  ...adresse,
  land: String(adresse.land || '').trim().toUpperCase() || 'DE',
})

const initialState = {
  timestamp: <string|false>false,

  userKontoAuswahl: '',

  adresseTyp: <adressTyp>'keine',

  shippingAdress: {
    ...emptyAdresse,
  },

  billingAdress: {
    ...emptyAdresse,
  },

  sameAdress: true,

  agbAkzeptiert: false,

  versandart: <shippingType>'dhl',
  //zahlungsart: <paymentType>'vorkasse',
}

export type tKasse = typeof initialState

/* +++++++++++++++++++++++++++++++++++++++++++++++++ */

export type action =
  | { type: 'applySavedCheckoutAddress'; payload: { typ: 'shipping' | 'billing'; address: tAdresse; addressType: adressTyp } }
  | {
      type: 'restoreKasse'
      payload: storageKasse
    }
  | {
      type: 'changeUserKontoAuswahl'
      payload: string
    }
  | {
      type: 'changeKasseAdresseTyp'
      payload: adressTyp
    }
  | {
      type: 'changeKasseSameAdress'
      payload: boolean
    }
  | {
      type: 'changeKasseAdresseField'
      payload: {
        typ: string
        field: adressField
        value: string
      }
    }
  | {
      type: 'toggleAgbAkzeptiert'
      payload?: undefined
    }

/* +++++++++++++++++++++++++++++++++++++++++++++++++ */

const save = (state: tKasse) => {
  setTimeout(()=>{
    localStorage.setItem('kasse', JSON.stringify(state))
  }, 0)
  return { ...state, timestamp: new Date().toISOString() }
}

const reducer = (state = initialState, {type,payload}: action): tKasse => {
  switch (type) {

    case 'applySavedCheckoutAddress': {
      if (payload.typ === 'billing') return save({ ...state, billingAdress: normalizeAdressLand(payload.address), sameAdress: false })
      let shippingAdress = normalizeAdressLand(payload.address)
      let billingAdress = state.billingAdress
      const previousContactIsShipping = state.adresseTyp === 'hausanschrift' || state.adresseTyp === 'keine'
      const nextContactIsShipping = payload.addressType === 'hausanschrift' || payload.addressType === 'keine'
      if (previousContactIsShipping !== nextContactIsShipping) {
        const contact = previousContactIsShipping ? state.shippingAdress : state.billingAdress
        const values = { email: contact.email || payload.address.email, telefon: contact.telefon || payload.address.telefon }
        // A station/business address moves the contact fields to billing. Keep
        // the customer's current recipient when applying a saved address too.
        if (nextContactIsShipping) shippingAdress = { ...shippingAdress, ...values }
        else billingAdress = { ...billingAdress, ...values }
      }
      return save({ ...state, shippingAdress, billingAdress, adresseTyp: payload.addressType,
        sameAdress: payload.addressType === 'hausanschrift' ? state.sameAdress : false })
    }

    /* -------------------------------------------------------------- */

    case 'restoreKasse': {

      return save({ ...state,
        adresseTyp: payload.adresseTyp,
        shippingAdress: normalizeAdressLand(payload.shippingAdress),
        billingAdress: normalizeAdressLand(payload.billingAdress),
        sameAdress: payload.sameAdress,
        agbAkzeptiert: payload.agbAkzeptiert,
        versandart: payload.versandart,
        timestamp: new Date().toISOString(),
      })
      
    }

    /* -------------------------------------------------------------- */

    case 'changeUserKontoAuswahl': {
      return save({ ...state, userKontoAuswahl:payload })
    }

    case 'changeKasseAdresseTyp': {
      const sameAdress = payload === 'hausanschrift'
      return save({ ...state,
        adresseTyp: payload,
        sameAdress,
      })
    }

    case 'changeKasseSameAdress': {
      return save({ ...state, sameAdress:payload })
    }

    case 'changeKasseAdresseField': {
      const ident = `${payload.typ}Adress`
      if (ident === 'shippingAdress' || ident === 'billingAdress') {
        const newState = clone(state)
        const adresse = newState[ident]
        const field = payload.field
        adresse[field] = field === 'land'
          ? String(payload.value || '').trim().toUpperCase() || 'DE'
          : payload.value
        return save(newState)
      }
    }

    case 'toggleAgbAkzeptiert': {
      return save({ ...state, agbAkzeptiert: !state.agbAkzeptiert })
    }

    /* -------------------------------------------------------------- */

    default: return state

    /* -------------------------------------------------------------- */
    
  }
}

export default reducer
